/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CallManagerControllerFindCallManagerPhoneNumberMappingsResponse {
  code: number;
  data: {
    items: {
      /** 매핑 고유 ID */
      _id: string;
      /** 병원 대표 번호(실제로 전화 받는 번호입니다.) */
      hospitalMainNumber: string;
      /** 트윌리오 수신 번호 */
      twilioIncomingPhoneNumber: string;
      /** 병원 회선 번호 (내선 목록) */
      phoneLineNumbers: string[];
      /** 알림 수신 담당자 User _id 목록 (DB에는 ObjectId로 저장) */
      notificationRecipientIds: string[];
    }[];
  };
  message: string;
}

export interface CallManagerControllerUpdateCallManagerPhoneNumberMappingsBodyRequest {
  /** 수정할 매핑 고유 ID */
  mappingId: string;
  /** 알림 수신 담당자 User _id 목록 (string, DB에는 ObjectId로 저장) */
  notificationRecipientIds?: string[];
}

export interface CallManagerControllerUpdateCallManagerPhoneNumberMappingsResponse {
  code: number;
  data: {
    items: {
      /** 매핑 고유 ID */
      _id: string;
      /** 병원 대표 번호(실제로 전화 받는 번호입니다.) */
      hospitalMainNumber: string;
      /** 트윌리오 수신 번호 */
      twilioIncomingPhoneNumber: string;
      /** 병원 회선 번호 (내선 목록) */
      phoneLineNumbers: string[];
      /** 알림 수신 담당자 User _id 목록 (DB에는 ObjectId로 저장) */
      notificationRecipientIds: string[];
    }[];
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerMappingByTwilioNumberResponse {
  code: number;
  data: {
    /** 병원 ID */
    hospitalId: string;
    /** 병원 대표번호 (E.164) */
    hospitalMainNumber: string;
    /** Twilio AI 수신번호 (E.164) */
    twilioIncomingPhoneNumber: string;
    /** 직원 수신 전화번호 목록 (E.164[]) */
    phoneLineNumbers: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean;
    /** PBX 동시 수용 회선 수 (1 이상) */
    lineCount?: number | null;
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerHospitalPhoneNumberResponse {
  code: number;
  data: {
    /** 병원 ID */
    hospitalId: string;
    /** AI 응대 사용 여부 */
    usingAI: boolean;
    /** 테스트 병원 여부 (true 시 call-manager가 AI 직통으로 라우팅) */
    isTest?: boolean;
    /** 병원 대표 번호 */
    hospitalMainNumber: string;
    /** 트윌리오 수신 번호 */
    twilioIncomingPhoneNumber: string;
    /** 병원 회선 번호 (내선 a,b,c 등) */
    lineNumbers?: string[] | null;
    /** 직통 녹음 사용 여부 (false면 직원 응대 시 후처리 생략) */
    isUsingDirectCallRecord?: boolean;
    /** 예약 가능 여부 */
    isReservationAvailable?: boolean | null;
    /** AI 응답 전환까지의 대기 시간(초) */
    autoAITResponseTime?: number | null;
    /** 환자(HService) ID */
    patientId?: string | null;
    /** 고객명 */
    patientName?: string | null;
    /** 고객 전화번호 */
    patientPhone?: string | null;
    /** 환자 생년월일 */
    patientBirth?: string | null;
    /** 환자 차트 번호 */
    patientChartNumber?: string | null;
    /** 환자 성별 */
    patientGender?: string | null;
    /** 환자 커스텀 태그 목록 (_id, name) */
    patientCustomTags?:
      | {
          /** 태그 ID */
          _id: string;
          /** 태그명 */
          name: string;
        }[]
      | null;
    /** 병원명 */
    name: string;
    /** 병원 소개 */
    introduction?: string | null;
    /** 병원 주소 */
    address?: string | null;
    /** 병원 운영 시간 */
    operatingHours?: string | null;
    /** 병원 운영 시간 참고사항 */
    careScheduleDescription?: string | null;
    /** 병원 예약 시간 */
    reservationHours?: string | null;
    /** 통화 알림 수신 담당자 ID 목록 (CallHistory 비정규화 저장·팝업 필터용) */
    notificationRecipientIds?: string[];
    /** PBX 환경 여부 */
    isPbx?: boolean;
    /** PBX 동시 수용 회선 수 (1 이상) */
    lineCount?: number | null;
    /** 예약 가능 일자 범위 */
    reservationPossibleDateRange?: string | null;
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerHistoriesResponse {
  code: number;
  data: {
    items: {
      /** 통화 내역 ID */
      id: string;
      /** 통화 고유 ID(내역과는 다릅니다.) */
      callSid: string | null;
      /** 병원 번호 */
      hospitalMainNumber: string;
      /** 발신번호 전체 번호(ex, +821051939519 */
      callerNumber: string;
      /** 고객명 */
      patientName: string | null;
      /** 발신자 국가 코드(ex, 82) */
      callerCountryCode: string | null;
      /** 발신자 국내 번호(ex, 1051939519) */
      callerNationalNumber: string | null;
      /** 통화 일시 (Asia/Seoul ISO 문자열) */
      callStartedAt: string;
      /** 예약 ID 목록 */
      reservationIds?: string[] | null;
      /** 병원 직원 확인 상태 */
      hospitalUserCheckStatus: "completed" | "needCheck" | null;
      /** 응대자 - 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
      respondentType: "patientUser" | "hospitalUser" | "ai" | "none" | null;
    }[];
    /** 필터 조건에 맞는 전체 건수 (페이지네이션용) */
    totalCount: number;
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerHistoryDetailResponse {
  code: number;
  data: {
    /** 통화 내역 ID */
    _id: string;
    /** 발신번호 전체 번호(ex, +821051939519 */
    callerNumber: string;
    /** 발신자 국가 코드(ex, 82) */
    callerCountryCode: string | null;
    /** 발신자 국내 번호(ex, 1051939519) */
    callerNationalNumber: string | null;
    /** 병원 직원 확인 상태 */
    hospitalUserCheckStatus: "completed" | "needCheck" | null;
    /** 응대자 - 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
    respondentType: "patientUser" | "hospitalUser" | "ai" | "none" | null;
    /** 예약 ID 목록 (통화에서 생성된 예약이 있을 때) */
    reservationIds: string[] | null;
    /** AI 요약 상태 (skipped: 요약 생략) */
    aiSummaryStatus: "processing" | "completed" | "failed" | "skipped" | null;
    /** 후처리 상태 (skipped: 후처리 생략) */
    postProcessingStatus: "processing" | "completed" | "failed" | "skipped" | null;
    /** 고객 정보 */
    patient: {
      /** HService ID */
      _id: string;
      /** 이름 */
      name: string;
      /** 차트 번호 */
      chartNumber: string | null;
      /** 생년월일 */
      birthdate: string | null;
      /** 성별 */
      gender: string | null;
      /** 휴대폰번호 */
      phoneNumber: string;
      /** 환자 국가 코드(ex, +82) - HService.countryCode(Countries.internationalDialingCodes)에 + 접두어 */
      countryCode: string | null;
    };
    /** 통화 정보 */
    callInfo: {
      /** 통화 일시 (Asia/Seoul ISO 문자열) */
      callStartedAt: string;
      /** 응대자 - 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
      respondentType: "patientUser" | "hospitalUser" | "ai" | "none";
      /** 병원 대표 번호 */
      hospitalMainNumber: string;
      /** 병원 회선 번호 - 수신번호 */
      phoneLineNumber: string;
      /** 통화 메모 */
      memo: string | null;
      /** 통화 메모 생성 일시 (Asia/Seoul ISO 문자열) */
      memoCreatedAt: string | null;
      /** 통화 메모 작성자 */
      memoWriter: {
        /** 사용자 ID */
        _id: string;
        /** 사용자명 */
        name: string;
      } | null;
      /** 통화 메모 수정 일시 (Asia/Seoul ISO 문자열) */
      memoUpdatedAt: string | null;
    };
    AiInfo: {
      /** AI 요약 (aiSummaryStatus가 skipped면 null) */
      summary: {
        content: string;
        hashtags: string[];
      } | null;
      /** 화자 분리 텍스트 (postProcessingStatus가 skipped면 null) */
      speakerTexts:
        | {
            /** 발화자 - 환자(patientUser), 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
            speaker: "patientUser" | "hospitalUser" | "ai" | "none";
            content: string;
            startTime: number;
          }[]
        | null;
      /** 음성 녹음 파일 URL (postProcessingStatus가 skipped면 null) */
      voiceMp3Url: string | null;
    };
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerPopupStatisticsResponse {
  code: number;
  data: {
    /** 총 수신 전화 */
    totalCalls: number;
    /** AI 응대 전화 */
    aiCalls: number;
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerPopupCallsResponse {
  code: number;
  data: {
    items: {
      /** 통화 내역 ID */
      id: string;
      /** 통화 고유 ID(내역과는 다릅니다.) */
      callSid: string | null;
      /** 발신번호 전체 번호(ex, +821051939519 */
      callerNumber: string | null;
      /** 발신자 국가 코드(ex, 82) - 통화 시점 발신번호 기준 */
      callerCountryCode: string | null;
      /** 발신자 국내 번호(ex, 1051939519) - 통화 시점 발신번호 기준 */
      callerNationalNumber: string | null;
      /** 환자 정보 (연결된 경우에만) */
      patient?: {
        /** HService ID */
        _id: string;
        /** 환자 휴대폰 번호 */
        phone: string;
        /** 고객명 */
        name: string;
        /** 성별 */
        gender: string | null;
        /** 차트 번호 */
        chartNumber: string | null;
        /** 생년월일 */
        birthdate: string | null;
        /** 환자 국가 코드(ex, +82) */
        countryCode?: string | null;
        /** 환자 커스텀 태그 목록 (_id, name) */
        customTags: {
          _id: string;
          name: string;
        }[];
      };
      /** 통화 메모 */
      memo: string | null;
      /** 응대자 - 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
      respondentType: "patientUser" | "hospitalUser" | "ai" | "none" | null;
      /** 통화 상태 (콜 팝업에는 전화가 오거나 연결된 상태만 조회) */
      status: "started" | "inProgress" | null;
      /** 통화 생성 일시 (UTC ISO 문자열) */
      createdAt: string;
    }[];
    /** 당일 통화 전체 건수 (페이지네이션용) */
    totalCount: number;
  };
  message: string;
}

export interface CallManagerControllerFindCallManagerPopupCallsDetailResponse {
  code: number;
  data: {
    /** 통화 내역 ID */
    callHistoryId: string;
    /** 통화 메모 */
    memo: string | null;
    /** 고객명 */
    name: string | null;
    /** 생년월일 */
    birthdate: string | null;
    /** 성별 */
    gender: string | null;
    /** 차트 번호 */
    chartNumber: string | null;
    /** 발신자 국가 코드(ex, +82) */
    callerCountryCode: string | null;
    /** 발신자 국내 번호(ex, 1051939519) */
    callerNationalNumber: string | null;
    /** 발신번호 전체 번호(ex, +821051939519 */
    callerNumber: string;
    /** 환자 정보 (연결된 경우에만) */
    patient?: {
      /** HService ID */
      _id: string;
      /** 고객명 */
      name: string;
      /** 차트 번호 */
      chartNumber: string | null;
      /** 생년월일 */
      birthdate: string | null;
      /** 성별 */
      gender: string | null;
      /** 휴대폰 번호 */
      phoneNumber: string;
      /** 환자 국가 코드(ex, +82) */
      countryCode: string | null;
      /** 커스텀 태그 목록 (_id, name) */
      customTags: {
        _id: string;
        name: string;
      }[];
    };
    /** 예약 ID 목록 (통화에서 생성된 예약이 있을 때) */
    reservationIds: string[] | null;
    /** AI 요약 상태 (skipped: 요약 생략) */
    aiSummaryStatus: "processing" | "completed" | "failed" | "skipped" | null;
    /** 후처리 상태 (skipped: 후처리 생략) */
    postProcessingStatus: "processing" | "completed" | "failed" | "skipped" | null;
    /** 통화 상태 (콜 팝업에는 전화가 오거나 연결된 상태만 조회) */
    status: "started" | "inProgress" | "ended" | "missed" | "failed" | null;
    /** 응대자 - 직원(hospitalUser), AI 콜매니저(ai), 통화 연결 전 종료(none) */
    respondentType: "patientUser" | "hospitalUser" | "ai" | "none" | null;
  };
  message: string;
}

export interface CallManagerControllerUpdateCallManagerPopupCallsMemoBodyRequest {
  /**
   * 통화 내역 ID
   * @minLength 1
   */
  callHistoryID: string;
  /** 통화 메모 */
  memo: string;
}

export interface CallManagerControllerUpdateCallManagerPopupCallsMemoResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface CallManagerControllerRegistCallManagerPopupCallPatientBodyRequest {
  /**
   * 통화 내역 ID
   * @minLength 1
   */
  callHistoryID: string;
  /**
   * 환자명
   * @minLength 1
   */
  name: string;
  /**
   * 환자 휴대폰 번호
   * @minLength 1
   */
  phone: string;
  /**
   * 국가 코드 ID
   * @minLength 1
   */
  countryCode: string;
}

export interface CallManagerControllerRegistCallManagerPopupCallPatientResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusBodyRequest {
  /**
   * 통화 내역 ID
   * @minLength 1
   */
  callHistoryID: string;
  /** 병원 직원 확인 상태 */
  hospitalUserCheckStatus: "completed" | "needCheck";
}

export interface CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface CallManagerControllerFindCallManagerPatientHistoriesResponse {
  code: number;
  data: {
    /** 통화 이력 목록 */
    items: {
      /** 통화 이력 ID */
      _id: string;
      /** 통화 시작 일시 (Asia/Seoul ISO 문자열) */
      callStartedAt: string;
      /** 발신자 국가 코드 */
      callerCountryCode: string | null;
      /** 발신자 국내 번호 */
      callerNationalNumber: string | null;
      /** AI 요약 (aiSummaryStatus가 skipped면 null) */
      aiSummary: {
        content: string;
        hashtags: string[];
      } | null;
      /** 응대자 */
      respondentType: "patientUser" | "hospitalUser" | "ai" | "none" | null;
      /** 병원 직원 확인 상태 */
      hospitalUserCheckStatus: "completed" | "needCheck" | null;
    }[];
    /** 전체 건수 (페이지네이션용) */
    totalCount: number;
  };
  message: string;
}

export type CallManagerControllerFindCallManagerPhoneNumberMappingsData =
  CallManagerControllerFindCallManagerPhoneNumberMappingsResponse;

export type CallManagerControllerUpdateCallManagerPhoneNumberMappingsData =
  CallManagerControllerUpdateCallManagerPhoneNumberMappingsResponse;

export interface CallManagerControllerFindCallManagerMappingByTwilioNumberParams {
  /** Twilio AI 수신번호 (E.164) */
  twilioIncomingPhoneNumber: string;
}

export type CallManagerControllerFindCallManagerMappingByTwilioNumberData =
  CallManagerControllerFindCallManagerMappingByTwilioNumberResponse;

export interface CallManagerControllerFindCallManagerHospitalPhoneNumberParams {
  /** 병원 대표 번호 */
  hospitalMainNumber: string;
  /** 환자 국가 코드 */
  patientCountryCode: string;
  /** 환자 국내 번호 */
  patientNationalNumber: string;
}

export type CallManagerControllerFindCallManagerHospitalPhoneNumberData =
  CallManagerControllerFindCallManagerHospitalPhoneNumberResponse;

export interface CallManagerControllerFindCallManagerHistoriesParams {
  /**
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /**
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /**
   * 병원 직원 확인 상태 필터 (all: 전체, completed: 확인완료, needCheck: 확인 필요)
   * @default "all"
   */
  hospitalUserCheckStatus?: "all" | "completed" | "needCheck";
  /** 필터 타입 (name: HService 이름, phone: 발신자 번호) */
  filterType?: "name" | "phone";
  /** 필터 값 (이름 혹은 전화번호 검색) */
  filterValue?: string;
  /**
   * 병원번호 필터
   * @default "[]"
   */
  hospitalMainNumber?: string;
}

export type CallManagerControllerFindCallManagerHistoriesData = CallManagerControllerFindCallManagerHistoriesResponse;

export interface CallManagerControllerFindCallManagerHistoryDetailParams {
  /**
   * 통화 내역 ID
   * @minLength 1
   */
  callHistoryID: string;
}

export type CallManagerControllerFindCallManagerHistoryDetailData =
  CallManagerControllerFindCallManagerHistoryDetailResponse;

export type CallManagerControllerFindCallManagerPopupStatisticsData =
  CallManagerControllerFindCallManagerPopupStatisticsResponse;

export interface CallManagerControllerFindCallManagerPopupCallsParams {
  /**
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /**
   * 미제공 시 limit 조건 없이 전체 조회
   * @min 1
   * @max 100
   */
  limit?: number;
}

export type CallManagerControllerFindCallManagerPopupCallsData = CallManagerControllerFindCallManagerPopupCallsResponse;

export interface CallManagerControllerFindCallManagerPopupCallsDetailParams {
  /** @minLength 1 */
  callHistoryID: string;
}

export type CallManagerControllerFindCallManagerPopupCallsDetailData =
  CallManagerControllerFindCallManagerPopupCallsDetailResponse;

export type CallManagerControllerUpdateCallManagerPopupCallsMemoData =
  CallManagerControllerUpdateCallManagerPopupCallsMemoResponse;

export type CallManagerControllerRegistCallManagerPopupCallPatientData =
  CallManagerControllerRegistCallManagerPopupCallPatientResponse;

export type CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusData =
  CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusResponse;

export interface CallManagerControllerFindCallManagerPatientHistoriesParams {
  /**
   * 환자(HService) ID. 필수.
   * @minLength 1
   */
  patientID: string;
  /**
   * 건너뛸 개수. 기본 0.
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /**
   * 조회할 개수. 기본 20, 최대 100.
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /**
   * 기간 시작일. 하이픈 포함 yyyy-mm-dd(예: 2026-01-02), 서울 기준. 필수.
   * @minLength 1
   * @pattern ^\d{4}-\d{2}-\d{2}$
   * @example "2026-01-02"
   */
  startDate: string;
  /**
   * 기간 종료일. 하이픈 포함 yyyy-mm-dd(예: 2026-01-31), 서울 기준. 필수.
   * @minLength 1
   * @pattern ^\d{4}-\d{2}-\d{2}$
   * @example "2026-01-31"
   */
  endDate: string;
}

export type CallManagerControllerFindCallManagerPatientHistoriesData =
  CallManagerControllerFindCallManagerPatientHistoriesResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description Call Manager 병원 전화번호 매핑 리스트 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerPhoneNumberMappings
     * @summary Call Manager 병원 전화번호 매핑 리스트 조회
     * @request GET:/v3/api/call-manager/phone-number-mappings
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerPhoneNumberMappingsData` success
     */
    callManagerControllerFindCallManagerPhoneNumberMappings: (params: RequestParams = {}) =>
      this.request<CallManagerControllerFindCallManagerPhoneNumberMappingsData, any>({
        path: `/v3/api/call-manager/phone-number-mappings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 병원 전화번호 매핑 단일 수정 (알림 담당자 등)
     *
     * @tags V3-CallManager
     * @name CallManagerControllerUpdateCallManagerPhoneNumberMappings
     * @summary Call Manager 병원 전화번호 매핑 단일 수정
     * @request PUT:/v3/api/call-manager/phone-number-mappings
     * @secure
     * @response `200` `CallManagerControllerUpdateCallManagerPhoneNumberMappingsData` success
     */
    callManagerControllerUpdateCallManagerPhoneNumberMappings: (
      data: CallManagerControllerUpdateCallManagerPhoneNumberMappingsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerUpdateCallManagerPhoneNumberMappingsData, any>({
        path: `/v3/api/call-manager/phone-number-mappings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Twilio 수신번호로 전화번호 매핑 조회 (역방향 조회)
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerMappingByTwilioNumber
     * @summary Twilio 수신번호로 전화번호 매핑 조회
     * @request GET:/v3/api/call-manager/mapping/by-twilio-number
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerMappingByTwilioNumberData` success
     */
    callManagerControllerFindCallManagerMappingByTwilioNumber: (
      query: CallManagerControllerFindCallManagerMappingByTwilioNumberParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerMappingByTwilioNumberData, any>({
        path: `/v3/api/call-manager/mapping/by-twilio-number`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description twilio 수신 전화번호를 기준으로 Call Manager 병원 전화번호 매핑, 환자 정보 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerHospitalPhoneNumber
     * @summary twilio 수신 전화번호를 기준으로 Call Manager 병원 전화번호 매핑, 환자 정보 조회
     * @request GET:/v3/api/call-manager/hospital/phone
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerHospitalPhoneNumberData` success
     */
    callManagerControllerFindCallManagerHospitalPhoneNumber: (
      query: CallManagerControllerFindCallManagerHospitalPhoneNumberParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerHospitalPhoneNumberData, any>({
        path: `/v3/api/call-manager/hospital/phone`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 히스토리 리스트 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerHistories
     * @summary Call Manager 히스토리 리스트 조회
     * @request GET:/v3/api/call-manager/histories
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerHistoriesData` success
     */
    callManagerControllerFindCallManagerHistories: (
      query: CallManagerControllerFindCallManagerHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerHistoriesData, any>({
        path: `/v3/api/call-manager/histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 히스토리 상세 조회. [권한·후처리 정책] - 직원/AI 통화 모두 후처리 데이터(음성녹음 mp3Url, speakerTexts, aiSummary 등)를 권한과 무관하게 내려줌. - `aiSummaryStatus=skipped` 이면 `AiInfo.summary` 는 `null`. - `postProcessingStatus=skipped` 이면 `AiInfo.voiceMp3Url`, `AiInfo.speakerTexts` 는 `null`. - 통화 최고 권한(ServiceSetting canControlMedipalAICall)은 FE에서만 UI 노출 여부 분기용으로 사용. - 직원 통화의 후처리 수행 여부는 업무조정 > AI 요약/통화 내용 설정으로 BE에서 판단.
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerHistoryDetail
     * @summary Call Manager 히스토리 상세 조회
     * @request GET:/v3/api/call-manager/history/detail
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerHistoryDetailData` success
     */
    callManagerControllerFindCallManagerHistoryDetail: (
      query: CallManagerControllerFindCallManagerHistoryDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerHistoryDetailData, any>({
        path: `/v3/api/call-manager/history/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 당일 총 수신 전화, AI 응대 전화 수 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerPopupStatistics
     * @summary Call Manager 팝업 당일 총 수신 전화, AI 응대 전화 수 조회
     * @request GET:/v3/api/call-manager/popup/statistics
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerPopupStatisticsData` success
     */
    callManagerControllerFindCallManagerPopupStatistics: (params: RequestParams = {}) =>
      this.request<CallManagerControllerFindCallManagerPopupStatisticsData, any>({
        path: `/v3/api/call-manager/popup/statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 통화 리스트 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerPopupCalls
     * @summary Call Manager 팝업 통화 리스트 조회
     * @request GET:/v3/api/call-manager/popup/calls
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerPopupCallsData` success
     */
    callManagerControllerFindCallManagerPopupCalls: (
      query: CallManagerControllerFindCallManagerPopupCallsParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerPopupCallsData, any>({
        path: `/v3/api/call-manager/popup/calls`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 통화 상세 조회
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerPopupCallsDetail
     * @summary Call Manager 팝업 통화 상세 조회
     * @request GET:/v3/api/call-manager/popup/calls/detail
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerPopupCallsDetailData` success
     */
    callManagerControllerFindCallManagerPopupCallsDetail: (
      query: CallManagerControllerFindCallManagerPopupCallsDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerPopupCallsDetailData, any>({
        path: `/v3/api/call-manager/popup/calls/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 통화 메모 등록 및 수정
     *
     * @tags V3-CallManager
     * @name CallManagerControllerUpdateCallManagerPopupCallsMemo
     * @summary Call Manager 팝업 통화 메모 등록 및 수정
     * @request POST:/v3/api/call-manager/popup/calls/memo
     * @secure
     * @response `200` `CallManagerControllerUpdateCallManagerPopupCallsMemoData` success
     */
    callManagerControllerUpdateCallManagerPopupCallsMemo: (
      data: CallManagerControllerUpdateCallManagerPopupCallsMemoBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerUpdateCallManagerPopupCallsMemoData, any>({
        path: `/v3/api/call-manager/popup/calls/memo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 통화 환자 등록
     *
     * @tags V3-CallManager
     * @name CallManagerControllerRegistCallManagerPopupCallPatient
     * @summary Call Manager 팝업 통화 환자 등록
     * @request POST:/v3/api/call-manager/popup/calls/patient/register
     * @secure
     * @response `200` `CallManagerControllerRegistCallManagerPopupCallPatientData` success
     */
    callManagerControllerRegistCallManagerPopupCallPatient: (
      data: CallManagerControllerRegistCallManagerPopupCallPatientBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerRegistCallManagerPopupCallPatientData, any>({
        path: `/v3/api/call-manager/popup/calls/patient/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Call Manager 팝업 통화 병원 직원 확인 상태 수정
     *
     * @tags V3-CallManager
     * @name CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatus
     * @summary Call Manager 팝업 통화 병원 직원 확인 상태 수정
     * @request POST:/v3/api/call-manager/popup/calls/hospital-user-check-status
     * @secure
     * @response `200` `CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusData` success
     */
    callManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatus: (
      data: CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerUpdateCallManagerPopupCallsHospitalUserCheckStatusData, any>({
        path: `/v3/api/call-manager/popup/calls/hospital-user-check-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자별 통화 이력 조회 (페이지네이션 + 기간 필터) **사용법 (Query 파라미터)** - `patientID` (필수): 환자(HService) ID - `startDate` (필수): 기간 시작일. 클라이언트는 하이픈 포함 `yyyy-mm-dd`(예: `2026-01-02`)로 전달. 서울 기준 - `endDate` (필수): 기간 종료일. 동일하게 `yyyy-mm-dd`(예: `2026-01-31`). startDate 이전이면 안 됨 - `offset` (선택, 기본 0): 건너뛸 개수 - `limit` (선택, 기본 20, 최대 100): 조회할 개수 **기간 조회 예시** - 2025년 3월 전체: `startDate=2025-03-01&endDate=2025-03-31` - 2024년 전체: `startDate=2024-01-01&endDate=2024-12-31` - 특정 일 하루: `startDate=2026-03-03&endDate=2026-03-03` **후처리 노출 규칙** - `aiSummaryStatus=skipped` 인 통화는 `aiSummary` 를 `null` 로 반환 클라이언트가 보내는 날짜는 서울(Asia/Seoul) 기준이며, 조회 시 UTC로 변환해 DB와 비교합니다.
     *
     * @tags V3-CallManager
     * @name CallManagerControllerFindCallManagerPatientHistories
     * @summary 환자 통화 이력 조회 (페이지네이션·startDate~endDate 기간)
     * @request GET:/v3/api/call-manager/patient/histories
     * @secure
     * @response `200` `CallManagerControllerFindCallManagerPatientHistoriesData` success
     */
    callManagerControllerFindCallManagerPatientHistories: (
      query: CallManagerControllerFindCallManagerPatientHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<CallManagerControllerFindCallManagerPatientHistoriesData, any>({
        path: `/v3/api/call-manager/patient/histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
